import { Link } from "react-router-dom"
import { contactPath, faqPath, registerPuzzlePath } from "~/common/paths"
import { useDocumentTitle } from "~/common/use-document-title"
import { SiteHeader } from "~/layouts/site-header"

export const AboutScreen = () => {
  useDocumentTitle("About")

  return (
    <>
      <SiteHeader />
      <main className="mx-auto max-w-2xl px-4 py-8 sm:py-14">
        <article className="prose prose-gray max-w-none">
          <h1 className="text-3xl font-semibold">About Wandering Puzzles</h1>

          <p className="mt-4 text-lg text-gray-700">
            Jigsaw puzzles deserve more than one weekend on someone&apos;s coffee table. Most get
            put back in a box, stashed in a closet, and forgotten. Wandering Puzzles is a tiny, free
            way to keep them moving.
          </p>

          <h2 className="mt-10 text-xl font-medium">How it works</h2>
          <ol className="mt-3 space-y-3 text-gray-700">
            <li>
              <strong>Register a puzzle</strong> from your shelf. We generate a short ID, a QR code,
              and a printable sticker.
            </li>
            <li>
              <strong>Stick the QR on the box</strong>. Anyone who finds the puzzle can scan it with
              their phone camera and land on the puzzle&apos;s journey page. No app, no login.
            </li>
            <li>
              <strong>Pass it on</strong>. Hand it to a friend, leave it at a coffee shop, mail it
              across the country.
            </li>
            <li>
              <strong>The next person logs their stop</strong>, where they finished it, what they
              thought, an optional photo. Then they pass it on too.
            </li>
          </ol>

          <h2 className="mt-10 text-xl font-medium">Why we built this</h2>
          <p className="mt-3 text-gray-700">
            Doing puzzles is a way to relax from the daily grind, often shared with others, and
            always curious where they end up. We wanted a way for that curiosity to actually have an
            answer.
          </p>

          <h2 className="mt-10 text-xl font-medium">The bare-bones promise</h2>
          <ul className="mt-3 space-y-2 text-gray-700">
            <li>
              <strong>Free, forever.</strong> No accounts to manage other than your email address.
            </li>
            <li>
              <strong>Privacy by default.</strong> Logged-out visitors never see email addresses or
              last names. Authors can log anonymously.
            </li>
            <li>
              <strong>No ads, no tracking SDKs.</strong> Just the puzzle, the QR, and the people who
              scan it.
            </li>
          </ul>

          <div className="mt-10 rounded-lg border bg-gray-50 p-5 text-sm">
            <p>
              Ready to start?{" "}
              <Link to={registerPuzzlePath({})} className="font-medium text-blue-600 underline">
                Register a puzzle
              </Link>
              , or check the{" "}
              <Link to={faqPath({})} className="font-medium text-blue-600 underline">
                FAQ
              </Link>{" "}
              and the{" "}
              <Link to={contactPath({})} className="font-medium text-blue-600 underline">
                contact form
              </Link>{" "}
              if anything is unclear.
            </p>
          </div>
        </article>
      </main>
    </>
  )
}
